const FINANCING_REQUESTS_ENDPOINT_KEY = '/financing-requests'
const FINANCING_SIMULATIONS_ENDPOINT_KEY = '/financing-requests/'

export { FINANCING_REQUESTS_ENDPOINT_KEY, FINANCING_SIMULATIONS_ENDPOINT_KEY }
